'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { GraphVisualization } from './GraphVisualization';
import { ResultBoxes } from './ResultBoxes';
import './bt-calculator.css';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { BalanceTransferCalculatorForm } from './Form';
export const BalanceTransferCalculator = () => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      paddingX: {
        xs: 3,
        sm: 4
      },
      paddingY: 4,
      gap: 4,
      display: "flex",
      flexDirection: "column"
    };
    t1 = <Typography variant="textLargeBold">See how much you could save by transferring your balance</Typography>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Grid size={{
      xs: 12,
      sm: 4
    }}><BalanceTransferCalculatorForm /></Grid>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      xs: 12,
      sm: 8
    };
    t4 = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Grid id="balance-transfer-calculator-graph" size={t3} sx={t4}>{" "}<GraphVisualization /></Grid>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatureViewed entityName="calculator" entitySection="balance_transfer_calculator" impressionPosition={0} impressionSection="in_content"><Box className="calculator-container" sx={t0}>{t1}<Grid container={true} spacing={4}>{t2}{t5}<Grid size={12}><ResultBoxes /></Grid></Grid><Typography variant="textSmall">Interest calculations are estimates. Actual finance charges will vary according to your payments and your credit card's terms.</Typography></Box></FeatureViewed>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};